import { Typography } from '@musinsa/mds';

export const EmptyProductList = () => (
  <div className="text-center py-10 mt-3 flex flex-col items-center grow">
    <Typography variant="body14pxMed" className="pb-0.5">
      검색 결과가 없습니다.
    </Typography>
    <Typography variant="body13pxReg" className="text-gray-600">
      상품명 / 브랜드명으로 검색하세요.
    </Typography>
  </div>
);
